import messageResource from '../../messageResource'
import {isOlVersion} from '../../constants'
import $ from 'jquery'
import {DateFormat} from '../../date_format'
import UserNameFormat from '../../util/UserNameFormat'
import UserDataLightBox from './UserDataLightBox'
import Spinner from '../../spin.min'
import CopyUserSettingsSelector from './CopyUserSettingsSelector'

function CreateUserLightBox()
{
}

CreateUserLightBox.prototype = new UserDataLightBox();

CreateUserLightBox.prototype.close_tab_confirmation_message_key = "user.add.js.close_tab_confirmation";

CreateUserLightBox.prototype.init = function(
    sectionsBuilder,
    userManagementData,
    accountSettings,
    allUsers,
    copyUserSettingsSelectCallback,
    copiedUserId,
    onHideCallback,
    userGroupEnabled,
    timeZoneGroupEnabled,
    showOvertime,
    otherProductStatusEditable
) {
    UserDataLightBox.prototype.init.call(this, sectionsBuilder, userManagementData, null,  accountSettings, showOvertime, otherProductStatusEditable);

    this.isDataLoaded = true;
    this.setTitle(messageResource.getMessage("user.add.js.new"));
    this.setNameInTitle( "" );

    this.copyUserSettingsSelectCallback = copyUserSettingsSelectCallback;

    // UsersSelector should be created after show LightBox, otherwise it will be created with wrong width
    this.initAfterShowing = function()
    {
        var allGroups = userManagementData.allUserGroups ? userManagementData.allUserGroups : userManagementData.allTimeZoneGroups;
        this.cl( this.initUsersSelector( allGroups, allUsers, copiedUserId,  userGroupEnabled, timeZoneGroupEnabled  ) );
    };

    this.setDeleteButtonVisibility( false );

    var buttonMessageKey = isOlVersion ? "user.add.js.create_user_with_invitation" : "user.add.js.create_user";
    this.setCommitButtonTitle(messageResource.getMessage(buttonMessageKey));

    $( this.lightBoxEl ).removeClass("editMode");
    $( this.lightBoxEl ).addClass("createMode");

    this.cancel_confirmation_message_key = "user.add.js.cancel_confirmation";

    this.onHideCallback = onHideCallback;

    this.needToConfirmWhenCopySettings = false;

    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 3, // The length of each line
        width: 2, // The line thickness
        radius: 4, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#bbbbbb', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    this.spinner = new Spinner( spinnerOptions );
    this.spinnerPlaceholder =  document.getElementById( this.lightBoxEl.id + "_usersSelectorSpinnerPlaceholder" );

    return this;
};

CreateUserLightBox.prototype.cl = function( func )
{
    var self = this;
    return function() { func.apply( self, arguments ); }
};

CreateUserLightBox.prototype.getDataToCommit = function()
{
    return this._userInputDataFetcher.getCreateUserInputData( this.userManagementData );
};

CreateUserLightBox.prototype.initUsersSelector = function( allUserGroups, allUsers, copiedUserId, ugrEnabled, tzgEnabled )
{
    // TODO remove this in future
    window.usersSelector = new CopyUserSettingsSelector();
    window.usersSelector.init( allUserGroups, allUsers, this.cl( this.onCopyUserSettingsSelect ), copiedUserId, ugrEnabled, tzgEnabled );
};

CreateUserLightBox.prototype.onCopyUserSettingsSelect = function( selectedUserId )
{
    if ( this.confirmCopySettingsIfNeeded() )
    {
        this.spinner.spin( this.spinnerPlaceholder );

        this.showOvertime = true;
        if ( this.copyUserSettingsSelectCallback )
            this.copyUserSettingsSelectCallback( this, selectedUserId );
    }
    else
    {
        window.usersSelector.enableInput();
        window.usersSelector.rollbackSelection();
    }
};

CreateUserLightBox.prototype.getLightBoxState = function ()
{
    var userInputData = this._userInputDataFetcher.getUserInputDataThatNotWillBeCopied( this.userManagementData );

    var sectionsErrorState = [];
    for( var i = 0; i < this._orderedSectionsList.length; i++ )
        sectionsErrorState.push( this._orderedSectionsList[i].getErrorState() );

    var errorState = { hasErrorInFooter: this._hasErrorInFooter(), sectionsErrorState : sectionsErrorState };

    var scrollPosition = this.getScrollPosition();

    var collectedChanges = this.collectedChanges;

    return { userInputData: userInputData, errorState: errorState, scrollPosition: scrollPosition, collectedChanges : collectedChanges };
};

CreateUserLightBox.prototype.setNeedToConfirmWhenCopySettings = function ( needToConfirmWhenCopySettings )
{
    this.needToConfirmWhenCopySettings = needToConfirmWhenCopySettings;
};

CreateUserLightBox.prototype.confirmCopySettingsIfNeeded = function ()
{
    return !this.needToConfirmWhenCopySettings || confirm( messageResource.getMessage("user.add.js.copy_settings_confirmation") );
};

CreateUserLightBox.prototype.show = function() {
    UserDataLightBox.prototype.show.call( this );
    this.initAfterShowing();
    this._sectionsBuilder.initAfterShowing( true );
};

CreateUserLightBox.prototype.hide = function ()
{
    UserDataLightBox.prototype.hide.call( this );
    this.hideSpinner();
    // TODO remove this in future
    window.usersSelector.clean();
    $( this.lightBoxEl ).removeClass( "accountCreated" );

    //see bug 47830: force usersSelector to close.
    if ( window.usersSelector ) window.usersSelector.usersCombo.collapse();

    if ( this.onHideCallback )
        this.onHideCallback();
};


CreateUserLightBox.prototype.changesDetected = function()
{

};


CreateUserLightBox.prototype.hideSpinner = function ()
{
    this.spinner.stop();
};

CreateUserLightBox.prototype.disableUserInputWhileSaving = function ()
{
    UserDataLightBox.prototype.disableUserInputWhileSaving.call( this );
    // TODO remove this in future
    window.usersSelector.disable();
};

CreateUserLightBox.prototype.enableUserInputWhileSaving = function ()
{
    UserDataLightBox.prototype.enableUserInputWhileSaving.call( this );
    // TODO remove this in future
    window.usersSelector.enable();
};

CreateUserLightBox.prototype.restoreState = function ( errorState, scrollPosition )
{
    this._restoreErrorState( errorState );
    this.setScrollPosition( scrollPosition );

    this._restoreSectionAfterLoad();
    this._changesCallback();
};

CreateUserLightBox.prototype._restoreErrorState = function ( errorState )
{
    var hasNotReplacedErrors = false;
    for( var i = 0; i < this._orderedSectionsList.length; i++ ) {
        var errState = errorState.sectionsErrorState[i];

        if ( errState ) {
            for( var p in errState ) {
                //noinspection JSUnfilteredForInLoop
                if( errState[p] )
                    hasNotReplacedErrors = true;
            }
        }

        ( this._orderedSectionsList[i].setErrorState( errState ) );
    }

    if ( errorState.hasErrorInFooter && hasNotReplacedErrors )
        this.printErrorInFooter( messageResource.getMessage( "user.add_edit.js.footer_error.exist_invalid_fields" ) );
};

CreateUserLightBox.prototype._restoreSectionAfterLoad = function ()
{
    for ( var i = 0; i < this._orderedSectionsList.length; i++ )
        if ( this._orderedSectionsList[i].sectionWasLoaded )
            this._orderedSectionsList[i].sectionWasLoaded();
};

CreateUserLightBox.prototype._showOvertime = function ()
{
    return true;
};

CreateUserLightBox.prototype.switchToAccountCreatedState = function ( invitationSent, addOneMoreUserCallback )
{
    var self = this;

    $( this.lightBoxEl ).addClass( "accountCreated" );
    this.isDataLoaded = false;
    this._commitEnabled = false;
    this.dataChanged = false;
    // TODO remove this in future
    window.usersSelector.disable();

    var userInfo = this._userInputDataFetcher.getUserInputDataForAccountCreatedState( this.userManagementData );

    var accountCreatedSectionEl = $('#' + this.lightBoxEl.id + '_accountCreatedSection');

    var formattedUserName = UserNameFormat.formatFML( userInfo.firstName, userInfo.lastName, userInfo.middleInitial );
    var invitationInfoHeader = messageResource.getEscapedMessage( "user.created.account_has_been_created", [formattedUserName] );
    accountCreatedSectionEl.find( ".invitationInfoHeader" ).html( invitationInfoHeader );

    accountCreatedSectionEl.toggleClass( "letterWillBeSent", !invitationSent );

    var formattedHireDate = new DateFormat( window.SystemSettings.dateFormat ).formatDate( userInfo.hireDate.parseJSONDate() );
    var invitationInfoText = invitationSent ?
                             messageResource.getEscapedMessage( "user.created.invitation_info.letter_sent", [userInfo.email] ) :
                             messageResource.getEscapedMessage( "user.created.invitation_info.hire_date_in_future", [userInfo.email, formattedHireDate] );
    accountCreatedSectionEl.find( ".invitationInfo" ).html( invitationInfoText );

    var inviteOneMoreUserButton = accountCreatedSectionEl.find( ".inviteOneMoreButton span" );
    inviteOneMoreUserButton.click( function() {
        self.cancel();
        addOneMoreUserCallback();
    });

    var closeButton = accountCreatedSectionEl.find( ".closeLink span" );
    closeButton.click( function() {
        self.cancel();
    });

    var overlayDiv = $( this.lightBoxEl ).find( ".accountCreatedOverlay" );
    if ( overlayDiv.length == 0 )
    {
        overlayDiv = $("<div class='accountCreatedOverlay'></div>");
        $( this.lightBoxEl ).append( overlayDiv );
    }
};

export default CreateUserLightBox


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/CreateUserLightBox.js